/*
 * @Author: Mike Cottingham
 * @Date: 2018-04-25 16:14:45
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2019-01-15 20:07:03
 */
import * as actions from '../../invoice/actions'
import {useState} from 'react'
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { Checkbox } from "material-ui";
import PropTypes from "prop-types";
import React from "react";
import model from "../../../model";
import styled from "styled-components";
import {Button  } from "material-ui";
import { directBillClients } from '../../../service/constants.js'
import { connect, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { faSpinner } from '@fortawesome/fontawesome-free-solid'

const dispatchToProps = (dispatch) => (
  bindActionCreators({
    ...actions
  }, dispatch)
)

const stateToProps = (state, props) => {
  return {}
}

const ListItem = styled.article`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #cdcdcd;
  cursor: pointer;

  &:hover {
    opacity: 0.75;
    background: #c7c7c7 !important;
  }
`;

const StyledP = styled.p`
  display: block;
  text-align: left;
  font-weight: bold;
  margin: 0.3rem;
`;

const Count = styled(StyledP)`
  flex: 0.3;
`;

const Name = styled(StyledP)`
  flex: 1.8;
`;

const PaymentIndicator = styled(StyledP)`
  flex: 0.5
`; 

const AppointmentType = styled(StyledP)`
  flex: 2
`; 

const PaymentSource = styled(StyledP)`
  flex: 3
`;
const ClientAppointmentListItem = ({ clientAppointment, onClick, onChange, selectedItems, singleExport }) => {
  const fullyPaid = clientAppointment.totalPaid === clientAppointment.appointments.length && clientAppointment.amountPaid === 0
  const isDirectBill = directBillClients.includes(clientAppointment.paymentSource) 
  const isAdmin = useSelector(state => state.auth.profile.isAdmin)

  const [loading, setLoading] = useState(false)
  const exportHandler = async (e) => {
    e.stopPropagation()
    setLoading(true)
    await singleExport(clientAppointment)
    setLoading(false)
  }

  const showExportElements = isAdmin && isDirectBill
  const cheched = !!selectedItems.find(el => el.id === clientAppointment.id)
  return (
    <ListItem
      onClick={onClick}
      style={{
        color: !isDirectBill && fullyPaid > 0 ? "white" : 'inherit',
        background: !isDirectBill && fullyPaid ? "#7eaf62" : 'inherit',
      }}
    >
      {
        showExportElements &&
        <Checkbox 
        className="export-checkbox"
        onClick={(e) => onChange(e, clientAppointment, cheched)}
        checked={cheched}
      />
      }
      <Count>({clientAppointment.appointments.length})</Count>
      {
        !isDirectBill && <PaymentIndicator>{clientAppointment.totalPaid !== 0 && `${clientAppointment.totalPaid} Paid`}</PaymentIndicator>
      } 
      <AppointmentType>
        {clientAppointment.appointments[0].type}
      </AppointmentType>
      <Name>
        {clientAppointment.client.firstName} {clientAppointment.client.lastName}
      </Name>
      <PaymentSource>
        {clientAppointment.paymentSource} {isDirectBill} 
      </PaymentSource>
      {
        showExportElements &&  
          <Button  
            color="secondary" 
            variant="raised" 
            className="single-export-btn" 
            onClick={exportHandler}
            disabled={loading}
          >
            {
              loading 
                ? <FontAwesomeIcon icon={faSpinner} spin />
                : "Export"
                
            }
          
          </Button >
      } 
    </ListItem>
  );
};

ClientAppointmentListItem.propTypes = {
  data: model.AppointmentShape,
  onClick: PropTypes.func,
};

export default connect(stateToProps,dispatchToProps)(ClientAppointmentListItem);
